import { ReactNode, useEffect, useState } from "react"
import { IVehicle } from "../../../../types/vehicle.type"
import { syncVelotrackData } from "../../../../common/services/vehicles.api"
import { bindFipeData } from "../../../../common/services/fipe.api"
import { useToastContext } from "../../../../common/components/ui/toast/toast.context"
import { initialState, VehicleDashboardContext } from "./VehicleDashboard.context"

type Props = {
  children: ReactNode;
  licensePlate: string;
};

export function VehicleDashBoardProvider(props: Props) {
  const [vehicle, setVehicle] = useState<IVehicle>(initialState.vehicle);
  const { notifySuccess } = useToastContext();

  useEffect(() => {
    async function loadVehicle(licensePlate: string) {
      const result = await syncVelotrackData(licensePlate)
      if (result.ok) {
        setVehicle(result.data as IVehicle)
        const bindfipe = await bindFipeData(result.data._id, result.data.fipeInfo)
        if (bindfipe.ok) {
          notifySuccess('Dados da FIPE atualizados com sucesso')
        }

      }
    }

    loadVehicle(props.licensePlate)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.licensePlate])

  const theState = { vehicle }
  return (
    <VehicleDashboardContext.Provider value={theState}>
      {props.children}
    </VehicleDashboardContext.Provider>
  )
}